export default "__VITE_ASSET__7GvYRh0n__ 1920w";